import api from "../../api";
import common from "./common";

const socket = {};

let wsock = null;

socket.init = async (data)=> {
    console.log("socket.init---------->", data);
    if (!data) return;
    if (!'WebSocket' in window) {
        return await common.alertModel('error', '您的设备不支持 WEBSOCKET 请更换设备重试');
    }
    wsock = new WebSocket(api.resHttp().socket + data.uuid);
    console.log("socket.init---------->", wsock);

    wsock.onopen = socket.onopen;
    wsock.onmessage = socket.onmessage;
    wsock.onsend = socket.onsend;

    // wsock.onerror = socket.onerror;
    // wsock.close = socket.onclose;
};

// 连接
socket.onopen = (data)=> {
    console.log('socket.onopen---------->', data);
};

// 数据发送
socket.onsend = (data)=> {
    console.log('socket.onsend---------->', data);
};

// 数据接收
socket.onmessage = async (res)=> {
    console.log('socket.onmessage---------->', JSON.parse(res.data));
    return await window.vue.$bus.emit('socket', true, JSON.parse(res.data));
};

// 错误
socket.onerror = (data)=> {
    console.log('socket.onerror---------->', data);
};

// 关闭
socket.onclose = (data)=> {
    if (wsock && data) wsock.close();
    console.log('socket.onclose---------->', data);
};

// 返回数据
socket.return = ()=> {
    return socket.onmessage();
    // return wsock.onmessage;
};

export default socket;



// WEBPACK FOOTER //
// ./src/assets/js/socket.js